import { collection, query, where, getDocs, doc, updateDoc, increment } from "firebase/firestore";
import { db } from "../firebase";

export async function validateCoupon(code, cartTotal) {
  if (!code?.trim()) return { valid: false, error: "Enter a coupon code" };
  const snap = await getDocs(query(collection(db, "coupons"), where("code", "==", code.trim().toUpperCase())));
  if (snap.empty) return { valid: false, error: "Invalid coupon code" };

  const coupon = { id: snap.docs[0].id, ...snap.docs[0].data() };

  if (!coupon.active) return { valid: false, error: "This coupon is no longer active" };
  if (coupon.expiresAt && coupon.expiresAt.toDate() < new Date()) return { valid: false, error: "This coupon has expired" };
  if (coupon.usageLimit && coupon.usedCount >= coupon.usageLimit) return { valid: false, error: "This coupon has reached its usage limit" };
  if (coupon.minOrderAmount && cartTotal < coupon.minOrderAmount) return { valid: false, error: `Minimum order of ₦${coupon.minOrderAmount.toLocaleString()} required` };

  let discount = 0;
  if (coupon.type === "percentage") discount = Math.round(cartTotal * coupon.value / 100);
  if (coupon.type === "fixed") discount = coupon.value;
  if (coupon.maxDiscount) discount = Math.min(discount, coupon.maxDiscount);

  return { valid: true, coupon, discount };
}

export async function useCoupon(couponId) {
  await updateDoc(doc(db, "coupons", couponId), { usedCount: increment(1) });
}
